module.exports = __webpack_public_path__ + "static/media/check.63e54c09.svg";